<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path == '/Maintain/Stock'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fas fa-wrench"></i>
            </span>
            <h3 class="kt-portlet__head-title">อะไหล่คงเหลือรายช่างซ่อม</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group ">
                  <label class="label">วันที่สร้าง(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">วันที่สร้าง(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">ชื่ออะไหล่:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-4" v-if="this.$root.user.profile.role != 'QI_QIMAINTAIN'">
                <div class="form-group">
                  <label class="label">ชื่อช่าง:</label>
                  <treeselect
                      v-model="qiUserId"
                      :multiple="true"
                      :load-options="LoadUsersIdOptions"
                      :async="true"
                      v-on:open="reLoadUsersIdOptions"
                      v-on:select="ClearAfterselect"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="qiUserId"
                    />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped table-bordered table-hover table-checkable"
                id="qiStockTable" style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all">รายการอะไหล่</th>
                    <th class="all">ชื่อช่าง</th>
                    <th class="all">จำนวนที่เบิก</th>
                    <th class="all">จำนวนที่ใช้งานแล้ว</th>
                    <th class="all">จำนวนที่คืนแล้ว</th>
                    <th class="all">จำนวนคงเหลือ<br>(พร้อมใช้งานทั้งหมด)</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
import DatatableWarning from "../../Shared/DatatableWarning";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
    <a href="#" @click.prevent="detailQi" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon">
      <i class="fa fa-search"></i>
    </a>
  </div>`,
  methods: {
    detailQi: function() {
      router.push({
        path: `/Maintain/Recv/Detail/${this.data.qiJobId}`,
      });
    },
  },
});

export default {
  components: {
    datepicker,
    Treeselect,
  },
  data: function() {
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      qiProductCodeOptions: [],
      qiUserId: [],
      qiUserOptions: [],
    };
  },
  methods: {
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    reLoadUsersIdOptions: function(){
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/QIJobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            type: ["JOB_QI_TYPE_DRAWBACK"],
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
    formReset: function(e) {
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      this.qiProductCode = null;
      this.qiUserId = [];
      $(`#jobsDateStart`).val("").trigger("change");
      $(`#jobsDateEnd`).val("").trigger("change");
      $(`#qiUserId`).val("").trigger("change");
      $(`#qiProductCode`).val("").trigger("change");
      this.formSubmit(e);
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ExportStockByUser",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIUserId: self.qiUserId,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#qiStockTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#qiStockTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;
    self.LoadreProductCodeOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#qiStockTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/SearchSpare",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
              EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
              QIProductCode: self.qiProductCode,
              QIUserId: self.qiUserId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [30, 50, 100],
        pageLength: 30,
        language: {lengthMenu: "Display _MENU_",},
        order: self.$root.user.profile.role == "QI_QIMAINTAIN" ? [[5, "desc"]] : [[1, "asc"]],
        columns: [
          { data: "materialNameShow", className: "text-center" },
            { data: "fullName", className: "text-center", visible: this.$root.user.profile.role != "QI_QIMAINTAIN" },

            {
                data: "issuedOut", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
            },
            {
                data: "used", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
},
            {
                data: "return", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
},
            {
                data: "avaliable", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
}
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/QIJob/QIStockList.vue